/* Purely local, device-specific settings (not part of the account profile). */
import { applyVolumes } from './audio';

const MUTE_KEY = 'aleaces_muted';
const SFX_KEY = 'aleaces_vol_sfx';
const MUSIC_KEY = 'aleaces_vol_music';

const readNum = (key: string, def: number): number => {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null) return def;
    const v = Number(raw);
    return Number.isFinite(v) ? Math.max(0, Math.min(100, v)) : def;
  } catch {
    return def;
  }
};

let muted = (() => {
  try {
    return localStorage.getItem(MUTE_KEY) === '1';
  } catch {
    return false;
  }
})();
let sfxVolume = readNum(SFX_KEY, 80);
let musicVolume = readNum(MUSIC_KEY, 50);

const listeners = new Set<() => void>();

function persist(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch { /* ignore */ }
}

function emit(): void {
  applyVolumes();
  for (const fn of listeners) fn();
}

export function isMuted(): boolean {
  return muted;
}

export function toggleMuted(): void {
  muted = !muted;
  persist(MUTE_KEY, muted ? '1' : '0');
  emit();
}

export function getSfxVolume(): number {
  return sfxVolume;
}

export function setSfxVolume(v: number): void {
  sfxVolume = Math.max(0, Math.min(100, Math.round(v)));
  persist(SFX_KEY, String(sfxVolume));
  emit();
}

export function getMusicVolume(): number {
  return musicVolume;
}

export function setMusicVolume(v: number): void {
  musicVolume = Math.max(0, Math.min(100, Math.round(v)));
  persist(MUSIC_KEY, String(musicVolume));
  emit();
}

export function subscribeSettings(fn: () => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
